import { render } from "./Product.vue?vue&type=template&id=7ab9d90c"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__